import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteNotificationTemplate } from "../../api/apiNotificationTemplates";

export const useDeleteNotificationTemplate = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteTemplateMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteNotificationTemplate,
        onSuccess: (res) => {
            toast.success(res?.message || "Template deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["notification-templates"] });
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || "Error deleting template");
        },
    });

    return { deleteTemplateMutate, isDeleting };
};
